export const scrollToViewById = (id: string, options?: ScrollIntoViewOptions) => {
  const blockElement = document.getElementById(id);
  let finalOptions: ScrollIntoViewOptions = { behavior: 'smooth' };
  if (options) {
    finalOptions = { ...finalOptions, ...options };
  }
  blockElement?.scrollIntoView(finalOptions);
};
